const priceFormat = value =>
// Nine Zeroes for Billions
  (Math.abs(Number(value)) >= 1.0e+9

    ? `${Math.abs(Number(value)) / 1.0e+9}B`
  // Six Zeroes for Millions
    : Math.abs(Number(value)) >= 1.0e+6

      ? `${Math.abs(Number(value)) / 1.0e+6}M`
    // Three Zeroes for Thousands
      : Math.abs(Number(value)) >= 1.0e+3

        ? `${Math.abs(Number(value)) / 1.0e+3}K`

        : Math.abs(Number(value)));


const buyerGuidePrice = (valueFrom, valueTo, type) => {
  // If 1 - Guilde is a price range - we can dispaly pricerangefrom and pricerangeto
  if (type == 1) {
    return `$${priceFormat(valueFrom)} - $${priceFormat(valueTo)}`;
  }

  // If 2 Guide price is offers above - we can only display the pricerangefrom
  if (type == 2) {
    return `$${priceFormat(valueFrom)}`;
  }

  // If anything else just display On request

  return ' On request';
};

export default { priceFormat, buyerGuidePrice };
